import { createTheme } from "@mui/material";

// Control Center nav bar color: #2c373f
// Invintus Medias logo green from the dot on the I: #6ab342

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },

    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },

    MuiScopedCssBaseline: {
      styleOverrides: {
        root: {
          "*": {
            boxSizing: "border-box",
            margin: "0",
            padding: "0",
          },
          html: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            display: "flex",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
          },
          body: {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
          },
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "32px 24px",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#E6E8F0",
        },
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#F3F4F6",

          ".MuiTableCell-root": {
            color: "#2c373f",
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: 0.5,
          },
        },
      },
    },
  },
  palette: {
    neutral: {
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
    action: {
      active: "#6B7280",
      focus: "rgba(55, 65, 81, 0.12)",
      hover: "#eeeeee",
      selected: "#d1d7df",
      disabledBackground: "rgba(55, 65, 81, 0.12)",
      disabled: "rgba(55, 65, 81, 0.26)",
    },
    background: {
      default: "#F9FAFC",
      paper: "#FFFFFF",
    },
    divider: "#E6E8F0",
    primary: {
      main: "#457093",
      // dark: "#001e3a",
    },
    fade: {
      main: "#6B7280",
    },
    success: {
      // based on Invintus Medias logo
      main: "#97bf88",
      contrastText: "#fff",
    },
    info: {
      main: "#2196F3",
    },
    warning: {
      main: "#FFB020",
      light: "#FFBF4C",
      dark: "#B27B16",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#D14343",
      light: "#DA6868",
      dark: "#922E2E",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#121828",
      secondary: "#65748B",
      disabled: "rgba(55, 65, 81, 0.48)",
    },
  },
  shape: {
    borderRadius: 4,
  },
  shadows: [
    "none",
    "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
    "0px 1px 2px rgba(100, 116, 139, 0.12)",
    "0px 1px 4px rgba(100, 116, 139, 0.12)",
    "0px 1px 5px rgba(100, 116, 139, 0.12)",
    "0px 1px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 6px rgba(100, 116, 139, 0.12)",
    "0px 3px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
    "0px 5px 12px rgba(100, 116, 139, 0.12)",
    "0px 5px 14px rgba(100, 116, 139, 0.12)",
    "0px 5px 15px rgba(100, 116, 139, 0.12)",
    "0px 6px 15px rgba(100, 116, 139, 0.12)",
    "0px 7px 15px rgba(100, 116, 139, 0.12)",
    "0px 8px 15px rgba(100, 116, 139, 0.12)",
    "0px 9px 15px rgba(100, 116, 139, 0.12)",
    "0px 10px 15px rgba(100, 116, 139, 0.12)",
    "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
    "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
  ],
  typography: {
    fontSize: 20,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    lineHeight: 1.75,
    button: {
      fontWeight: 400,
    },
    // body1: {
    //   fontSize: "1rem",
    //   fontWeight: 400,
    //   lineHeight: 1.5,
    // },
    // body2: {
    //   fontSize: "0.875rem",
    //   fontWeight: 400,
    //   lineHeight: 1.57,
    // },
    // subtitle1: {
    //   fontSize: "1rem",
    //   fontWeight: 500,
    //   lineHeight: 1.75,
    // },
    // subtitle2: {
    //   fontSize: "0.875rem",
    //   fontWeight: 500,
    //   lineHeight: 1.57,
    // },
    // subtitle2faded: {
    //   fontSize: "0.875rem",
    //   opacity: 0.3,
    //   fontWeight: 500,
    //   lineHeight: 1.57,
    // },
    // overline: {
    //   fontSize: "0.75rem",
    //   fontWeight: 600,
    //   letterSpacing: "0.5px",
    //   lineHeight: 2.5,
    //   textTransform: "uppercase",
    // },
    // caption: {
    //   fontSize: "0.75rem",
    //   fontWeight: 400,
    //   lineHeight: 1.66,
    // },
    h1: { fontSize: "3.052rem", fontWeight: 500 },
    h2: { fontSize: "2.441rem", fontWeight: 500 },
    h3: { fontSize: "1.953rem", fontWeight: 500 },
    h4: { fontSize: "1.563rem", fontWeight: 500 },
    h5: { fontSize: "1.25rem", fontWeight: 500 },
  },
});

export default theme;
